module.exports = __webpack_public_path__ + "img/herty-field.aa1230a1.jpg";